import commonZh from './locales/zh/common'
import homeZh from './locales/zh/home'
import consultZh from './locales/zh/consult'
import aboutZh from './locales/zh/about'
import legalZh from './locales/zh/legal'

export const zhHans = {
    product: "评估量表",
    training: "培训信息",
    mation: "新闻资讯",
    onlineScoring: "在线计分",
    about: "关于我们",
    headerMainSystem: "主试系统",
    headerScoringService: "计分系统",
    headerLangZh: "中文",
    headerLangEn: "English",
    headerMenuHome: "首页",
    headerMenuTrain: "培训课程",
    headerMenuProduct: "评估量表",
    headerMenuConsult: "咨询中心",
    headerMenuNews: "新闻中心",
    headerMenuAbout: "关于我们",
    headerMenuAboutYulin: "关于育林",
    homeHeroTitle: "致力于开发标准化的筛查、诊断、评估量表。",
    homeHeroDesc: "此刻，\n我们正在为约1000名医生、康复/治疗师、特殊教师、社会工作者及其他专业人士提供服务。",
    homeHeroPrimaryCta: "查看评估量表",
    homeHeroSecondaryCta: "进入主试系统",
    homeProductTitle: "评估量表",
    homeProductTagline: "标准化 · 心理量表",
    homeProductDesc: "我们提供包括神经发育障碍、适应行为、运动发展、学习困难等专业的评估量表，构建了自婴儿至老年的全生命周期标准化心理评估工具。",
    homeProductFallbackSummary: "儿童孤独症评定量表第二版中文版",
    homeTrainingTitle: "新技术 · 培训课程",
    homeTrainingTagline: "新技术 · 培训课程",
    homeTrainingDesc: "我们持续为客户提供由心理学、教育学、临床医学、康复医学等领域内权威专家担任讲师的高价值、高频次的培训课程。",
    homeExpertTitle: "研发团队",
    homeExpertTagline: "业界权威 · 研发智库",
    homeExpertDesc: "我们建立了由心理学、教育学、临床医学、康复医学专家组成的权威研发团队。",
    homeNewsTitle: "最新动态",
    homeNewsHeading: "新闻",
    homeNewsDesc: "公司新闻与行业动态持续更新。",
    homeViewDetail: "查看详情",
    homeViewMore: "查看更多",
    homeViewMoreEllipsis: "更多...",
    homeViewMoreNews: "进入新闻中心",
    homeNewsCompany: "公司新闻",
    homeNewsIndustry: "行业资讯",
    newsCenterIntro: "我们建立中国本土常模数据，深度联动全球高校、医疗机构与科研院所，\n研发兼具专业性与本土适配性的心理测评工具及整体解决方案，\n全方位助力临床诊疗康复、人才教育培养、个体潜能开发与国民心理健康发展，\n这是华晟育林一以贯之的初心与使命。",
    newsCenterEmpty: "暂无新闻数据",
    newsCenterHeroAlt: "新闻中心展示插画",
    newsCenterReadMore: "查看详情",
    homeEmptyProduct: "暂无量表数据",
    homeEmptyTraining: "暂无培训数据",
    homeEmptyExpert: "暂无专家数据",
    homeEmptyNews: "暂无新闻数据",
    homeStatusPending: "未开始",
    homeStatusRunning: "进行中",
    homeStatusEnded: "已结束",
    footerGroupAbout: "关于我们",
    footerGroupLatest: "最新动态",
    footerGroupCompany: "华晟育林",
    footerGroupService: "产品与服务",
    footerGroupLaw: "法律",
    footerGroupContact: "联系",
    footerAboutUs: "关于我们",
    footerMenuConsult: "咨询中心",
    footerLatestNews: "最新动态",
    footerContactUs: "联系我们",
    footerPhone: "电话",
    footerEmail: "邮箱",
    footerWechat: "微信公众号",
    footerOfficialWechat: "华晟育林官方微信",
    footerWechatId: "微信号: hsyl-tech",
    footerEducationSupport: "教育支持计划",
    footerServiceScale: "评估量表",
    footerServiceTraining: "培训课程",
    footerServiceScoring: "计分系统",
    footerLawTerms: "使用条款",
    footerLawEthics: "道德合规",
    footerLawIP: "版权声明",
    footerLawPrivacy: "个人信息保护政策",
    footerLawSecurity: "信息保护",
    consultTitle: "咨询中心",
    consultDesc: "咨询中心频道正在完善中。您可先通过培训课程和关于我们页面获取支持信息，我们将持续补充专业咨询服务内容。",
    consultActionTraining: "查看培训课程",
    consultActionContact: "联系我们",
    news: "公司新闻",
    industry: "行业资讯",
    introduction: "公司简介",
    team: "研发智库",
    intellectual: "版权声明",
    certificate: "专利证书",
    authorization: "授权书",
    computer: "计算机软件著作权等级证书",
    service: "产品服务",
    service1: "测验与量表",
    service2: "培训课程",
    privacy: "隐私安全",
    rights: "版权所有",
    disclaimers: "免责声明",
    business: "经营许可证编号",
    link: "联系我们",
    cooperation: "中外合作",
    cooperationDesc: "本公司致力于与国内外专家合作，努力将国外高水平心理测量技术和服务技术引进中国，并且立足于国内研究，与专家合作开发适用于本土文化的测量技术和产品。同时，本公司也提供相关资质培训，帮助更多的心理测评从业者提升专业技能和水平。",
    experience: "专业经验",
    experienceDesc: "本公司的管理层和骨干成员都已在本行业耕耘十几年，对于心理测量技术和服务有着深入的研究和理解，能够为客户提供最适合的方案和服务。他们的经验和专业水平，是本公司最宝贵的财富，也是客户最可靠的保证。",
    support: "专家支持",
    supportDesc: "本公司的技术团队由一群心理学、教育学、计算机等领域的专家和学者组成，具有丰富的学术背景和研究与实践经验。热爱心理学应用和服务事业，立志为中国正在为帮助有需要的儿童青少年和他们的家庭而工作的专业技术人员，提供优质的工具和有效的帮助。本公司全体成员，希望通过我们的努力，助力我国专业技术人员能为有需要的儿童青少年以及家庭提供更好的服务。",
    achievements: "成果成就",
    achievementsDesc: "华晟育林公司将为教育、临床等应用领域提供优质的、与国际接轨的测量和服务技术。中国在许多前沿科技领域已经取得了傲人的成就，但是在心理测量技术以及应用服务方面的发展还任重道远，需要砥砺前行。本公司全体成员将竭尽全力，与国内外更多专家学者联手合作，为提升国内的测量技术做出我们自己的贡献。",
    goal: "目标愿景",
    goalDesc: "“团结、诚信、严谨、快乐”是我们的工作风格；脚踏实地做好工作，为社会贡献力量，是我们的共同目标。",
    all: "全部",
    other: "其他信息",
    identification: "用户识别信息",
    identificationDesc: "当用户使用邮箱（手机号码）及密码通过验证成为产品的注册用户后，该手机号码（邮箱）和密码即成为用户使用本公司产品或服务的识别凭证，用户本人须对所有使用该识别凭证在本公司各产品或服务中所采取的一切行为负责。本公司建议用户不要向任何第三方披露自己的密码。如果泄漏密码，用户可能丢失个人识别信息及保存在本公司服务器上的资料。因此，请妥善保管登录手机号（邮箱）和密码。由于用户自己的原因导致用户识别信息泄露或丢失时，本公司对此和由此将引发得一切后果都不承担责任。",
    collected: "本公司收集的",
    collectedDesc: "本公司收集的资料可能包括用户来自何路径（不论该路径是否在本公司网站或软件）、用户的浏览器向本公司网站发送的资料，以及用户的 IP 地址。在用户向本公司提交反馈时，用户可以自主决定是否填写联系方式，该联系方式类型不限，可能被用于旨在了解或解决用户提交的问题的回访或反馈。",
    data: "资料",
    companyInfo: "本公司用户资料",
    companyInfoDesc: "本公司不向任何第三方展示、出售或出租任何用户个人资料。本公司可能使用用户提供的资料与用户联络并向用户传递信息，例如产品服务方面的通知、最新产品等。",
    use: "的使用和保管",
    security: "安全性",
    securityDesc: "用户资料存储于本公司的服务器中。用户资料安全是本公司信誉的基础，本公司采用行业标准尽力维护用户个人资料的隐私性，如果您对我们的个人信息保护有任何疑问，请联系我们。本公司有权根据国家法律/行业规范/自身发展等需要随时修改此隐私保护策略。",
    company: "华晟育林",
    companyDesc: "「华晟育林」一词及各个华晟育林标志均为华晟育林的商标。所采用的商标及标志均属广东省华晟育林科技有限公司（以下简称：华晟育林）的财产。网站上出现的其他名字可能属于有关其他拥有人的商标。本网站所提到或使用的产品、技术或程式的权利可能是由华晟育林或其他第叁者所保留，并无于此就该等知识产权提供任何许可。任何使用本网站人士不得在未有华晟育林的书面许可的情况下分发、修改、传送或使用本网站的任何内容作公众或商业用途。",
    content1: "本网站所载的一切资料仅供参考之用。虽然在拟备该等资料时已尽量确保其准确性，在法例允许的范围内，广东省华晟育林科技有限公司（以下简称：华晟育林）并不保证该等资料的准确性、完整性或时效性，亦不会就任何该等资料所引致或依赖该等资料而引致的后果承担任何责任。华晟育林保留随时修改本网站资料的权利，而毋须预先作出任何通知。",
    content2: "本网站中的资料的提供并不包括任何暗示或明示的保证（包括但不限于任何就其可用性、质量、对其用途的适切性或任何非违反的任何保证）；华晟育林亦无就本网站的运作的持续性、是否会受到任何干扰、电脑病毒或其他问题的侵入提出任何保证。",
    content3: "本网站可能包含第叁者网站的连结，目的仅为方便浏览人士，并不明示或暗示华晟育林对该等第叁者或其产品或服务的确认、批准、建议或偏好。华晟育林并无参与发展该等网站亦对该等网站无任何制作权或其他控制权。华晟育林就该等第叁者网站上所载的资料的内容或准确性不负任何责任。任何人士使用或接达该第叁者网站或其产品或服务，风险概由有关人士自行承担。华晟育林就任何资料透过本网站向任何第叁方的转送或提供的安全性不作出任何保证，亦不会就任何使用者从本网站接达其他网站或与其他网站的交流而引致的后果承担任何责任。",
    personalAchievements: "个人成就",
    findings: "研究成果",
    time: "发布时间",
    speaker: "主讲人",
    form: "形式",
    online: "线上",
    offline: "线下",
    notStart: '未开始',
    starting: '进行中',
    ended: '已结束',
    pilotTraining: "主试培训",
    trainingFormat: "培训形式",
    trainingTime: "培训时间",
    trainingLocation: "培训地点",
    download: "下载",
    ourService: "我们的服务",
    onlineJudge: "在线评测",
    proTitle: "卡斯2(中文版)",
    proDesc1: "儿童孤独症评定量表第二版中文版",
    proDesc2: "是用于孤独症临床诊断的评估量表，在国际上享有盛名，并且在许多国家广泛应用",
    proDesc3: "标准版：小于6岁；或大于6岁，且IQ≤79；或有严重沟通障碍",
    proDesc4: "高功能版：大于6岁；并且IQ≥80；并且能流畅沟通",
    newScale: "新量表",
    developing: "正在研发",
    secondEdition: "第二版",
    short: "简称",
    revisionHost: "修订主持人",
    age: "适用年龄",
    name: "贾美香 李毓秋 寿小婧",
    above: "0岁及以上",
    publicationTime: "中文版出版时间",
    date: "2024年4月",
    format: "",
    formatDesc: "",
    content4: "《儿童孤独症评定量表第二版》(简称卡斯2，英文为CARS2)是用于孤独症临床诊断的评估量表，在国际上享有盛名，并且在许多国家广泛应用。",
    content5: "《儿童孤独症评定量表第二版（中文版）》 [简称：卡斯2（中文版），英文为CARS2(CN)]，是经美国版权公司Western Psychological Services （以下简称：WPS）授权，广东省华晟育林科技有限公司（以下简称：华晟育林）在中国引进和修订的中文版本。与美国原版一样，《卡斯2(中文版)》共包括两个版本的量表：适用于一般孤独症诊断的标准版[卡斯2（中文）-标准版]和适用于高功能孤独症的高功能版[卡斯2(中文)-高功能版]。还包括一份家长或照顾者问卷 [卡斯2(中文版)-家长问卷]，用于从家长或照顾者方面了解被评者的日常情况，配合标准版或高功能版使用。",
    content6: "国内著名临床专家贾美香教授领衔主持了《卡斯2(中文版)》的修订。量表的修订成功与顺利发行，为我国临床儿童孤独症评估和诊断工作，提供了一个具有正式版权的国际高水平诊断量表，使得我国在孤独症的临床评估和诊断技术能够与国际接轨，为我国专业技术人员在孤独症的临床诊断以及开展相关研究等方面提供了有利的工具。",
    applicableScope: "适用范围",
    scopeDesc1: "卡斯2(中文)-标准版[CARS2(CN)-ST]结合家长或照顾者问卷，适用于",
    scopeDesc2: "1. 被评儿童年龄小于6岁；或 <br/>2. 年龄大于6岁，且IQ≤79；或 <br/>3. 有严重沟通障碍。",
    scopeDesc3: "卡斯2(中文)-高功能版[CARS2(CN)-HF]结合家长或照顾者问卷，适用于",
    scopeDesc4: "1. 被评估者年龄大于6岁；并且 <br/> 2. IQ≥80；并且  <br/>3. 能流畅沟通。",
    scopeDesc5: "",
    evaluationMethod: "评估方式",
    methodDesc: "",
    methodDesc1: "CARS2-ST：临床医师基于对儿童的观察、家长填写的家长与照顾者问卷，以及其他有关信息完成评定。",
    methodDesc2: "CARS2-HF：临床医师需基于直接观察及、主要照顾者，以及其他有关信息所提供的儿童在不同环境中行为表",
    methodDesc3: "现的信息完成评定。",
    methodDesc4: "",
    methodDesc5: "",
    methodDesc6: "",
    methodDesc7: "",
    methodDesc8: "",
    methodDesc9: "",
    methodDesc10: "",
    methodDesc11: "",
    methodDesc12: "",
    methodDesc13: "",
    methodDesc14: "",
    methodDesc15: "",
    evaluationResults: "评定结果",
    resultsDesc: "可以给出被评估者的百分等级分数、T-分数、以及孤独症症状程度分组建议。",
    advantage: "优势",
    advantageDesc1: "涉及面广，能反映出孤独症实验性研究的成果；",
    advantageDesc2: "适用所有年龄段和不同功能水平的儿童；",
    advantageDesc3: "在直接的行为观察的基础上提供更为客观、足量的证据；",
    advantageDesc4: "有助于形成康复训练计划；",
    advantageDesc5: "有助于跟家长进行诊断后的反馈和沟通。",
    qualification: "使用资格",
    qualificationDesc: "接受过自闭症谱系障碍专业知识培训，且能解读评定结果的临床专业人员。",
    address: "珠海市高新区唐家湾镇湾创路88号4层404室",
}
Object.assign(zhHans, commonZh, homeZh, consultZh, aboutZh, legalZh)
export default zhHans;



// WEBPACK FOOTER //
// ./src/i18n/zh.js